
import { Component, Vue, Prop } from "vue-property-decorator"
import { Formatting } from "../../util/formatting"
const dateFormat = new Formatting.DateFormatting()

import * as cdn from "@coredination/components"

import EntityEventSubscription from "@/graphql/subscription/entityevent.graphql"
import CustomerDetailQuery from "@/graphql/customer/customerdetail.graphql"
import CustomerAssetsQuery from "@/graphql/asset/customerassets.graphql"

@Component({
    components: {
        JobList: () => import("@/components/misc/JobList.vue"),
        AssetList: () => import("@/components/misc/AssetList.vue"),
    },
    apollo: {
        me: cdn.graphql.me,
        customer: {
            query: CustomerDetailQuery,
            skip() {
                return !this.uuid
            },
            variables() {
                return { uuid: this.uuid }
            }
        },
        customerAssets: {
            query: CustomerAssetsQuery,
            variables() {
                return {
                    uuid: this.uuid,
                }
            },
            skip() {
                return !this.uuid
            },
        },
    }
})
export default class CustomerAssetList extends Vue {
    @Prop()
    uuid!: string

    me: any = {}
    customer: any = {}
    customerAssets: any[] = []
    activeTab: number = 3

    refresh() {
        if (this.$apollo.queries.customerAssets &&
            typeof this.$apollo.queries.customerAssets.refetch == "function")
            this.$apollo.queries.customerAssets.refetch()
    }

    get loadingCustomerAssets() {
        return this.$apollo.queries.customerAssets.loading
    }

}
